module.exports = __webpack_public_path__ + "8a70c363f2aeb65de9a10cef9fe3a5c7.svg";


//////////////////
// WEBPACK FOOTER
// ./images/standardProviderPin.svg
// module id = 44
// module chunks = 0